/**
 * Verification level, per docs/VERIFICATION.md.
 *
 *   none      — email confirmed only (level 1)
 *   contact   — phone confirmed and FMJD identity matched (2A)
 *   identity  — plus a check binding the person to the identity (2B)
 *
 * The distinction is shown honestly rather than flattened to a tick: 2A proves
 * control of contact details, which is not the same as proving who someone is,
 * and an arbiter reading the list needs to see which is which.
 */

export type Level = "none" | "contact" | "identity";

const STYLES: Record<Level, { label: string; title: string; fg: string; bg: string }> = {
  none: {
    label: "—",
    title: "Email address confirmed only",
    fg: "#9e9e9e",
    bg: "transparent",
  },
  contact: {
    label: "Verified",
    title:
      "Contact verified: telephone confirmed, and FMJD ID matched against the FMJD database",
    fg: "#00695c",
    bg: "#e0f2f1",
  },
  identity: {
    label: "ID verified",
    title: "Identity verified: checked against a document or the FMJD address on file",
    fg: "#1b5e20",
    bg: "#c8e6c9",
  },
};

export function VerificationBadge({ level }: { level: Level }) {
  const s = STYLES[level] ?? STYLES.none;
  if (level === "none") {
    return (
      <span style={{ color: s.fg, fontSize: 13 }} title={s.title}>
        {s.label}
      </span>
    );
  }
  return (
    <span
      title={s.title}
      style={{
        fontSize: 12,
        fontWeight: 600,
        color: s.fg,
        background: s.bg,
        padding: "2px 8px",
        borderRadius: 10,
        whiteSpace: "nowrap",
      }}
    >
      {s.label}
    </span>
  );
}
